<template>
  <div class="datanalysis">
    <div class="left">
      <ul class="left-one">
        <li v-for="(item, index) in menu" @click="onMenu(item)">
          <div class="left-one-item">
            <div>
              <i :class="`icon-font ${item.icon}`"></i>
              <span>{{item.text}}</span>
            </div>
            <i class="iconfont icon-up" :class="item.id === currentOne ? 'rotate':''"></i>
          </div>
          <div class="left-two" v-show="item.id === currentOne">
            <div v-for="(items, itemsIndex) in item.items" class="left-two-item"
                 :class="items.id === currentTwo ? 'select':''" @click.stop="onSub(items)">
              <span>{{items.text}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="currentOne===2" class="right">
      <iframe ref="oneTableIframe" name="oneTableIframe" class="oneTableIframe" :src="getOneTableURL"
              frameborder="0"></iframe>
    </div>
    <div v-show="currentOne===1" class="right">
      <teacherStatistics v-if="currentOne === 1 && currentTwo === 10"></teacherStatistics>
      <studentStatistics v-if="currentOne === 1 && currentTwo === 11"></studentStatistics>
      <teachingStatistics v-if="currentOne === 1 && currentTwo === 12"></teachingStatistics>
      <propertyStatistics v-if="currentOne === 1 && currentTwo === 13"></propertyStatistics>
      <bookStatistics v-if="currentOne === 1 && currentTwo === 14"></bookStatistics>
    </div>
  </div>
</template>

<script>
  import teacherStatistics from "../components/datanalysis/teacherStatistics";
  import studentStatistics from "../components/datanalysis/studentStatistics";
  import teachingStatistics from "../components/datanalysis/teachingStatistics";
  import propertyStatistics from "../components/datanalysis/propertyStatistics";
  import bookStatistics from "../components/datanalysis/bookStatistics";
  export default {
    name: "datanalysis",
    components: {teacherStatistics,studentStatistics,teachingStatistics, propertyStatistics,bookStatistics},
    data() {
      return {
        currentOne: 1,
        currentTwo: 10,
        menu: [
          {
            id: 1,
            text: '综合画像',
            icon: 'bcsxushoucang',
            items: [
              {
                id: 10,
                text: '教职工统计'
              },
              {
                id: 11,
                text: '学生统计'
              },
              {
                id: 12,
                text: '教学统计'
              },
              {
                id: 13,
                text: '资产统计'
              },
              // {
              //   id: 14,
              //   text: '图书'
              // }
            ]
          },
          // {
          //   id: 2,
          //   text: '一张表',
          //   icon: 'bcsxushoucang',
          //   items: [
          //     {
          //       id: 20,
          //       text: '一张表'
          //     }
          //   ]
          // },
        ],

      }
    },
    methods: {
      // 点击一级菜单
      onMenu(item) {
        if (this.currentOne === item.id) {
          this.currentOne = null
          return
        }
        this.currentOne = item.id
        this.currentTwo = item.items[0].id
      },
      // 点击二级菜单
      onSub(items) {
        this.currentTwo = items.id
      },


    },
    computed: {
      getOneTableURL() {
        return 'http://jkttb.itdaka.cn:8081/shall/cgi-bin/access/a2d3774f5cf84dd18469ec0501db2c41?url=http://jkttb.itdaka.cn:8083/lightapp/awatch/user/login&state=006EC7'
      }
    },
    watch: {},
    mounted() {

    },
  }
</script>

<style lang="stylus" scoped>
  @media screen and (max-width: 1440px)
    .datanalysis
      width 1900px !important

    .left
      width 9% !important

    .right
      width 91% !important

      .book-item-right
        width 32.5% !important

      .student-item
        width 32% !important

      .preBox
        width 69% !important

  .dialogBox
    width 100%
    height 750px
    display flex
    flex-wrap wrap
    .item
      width 50%
      margin 5px 0
      display flex
      align-items center
      justify-content space-between
      padding 0 25px
      box-sizing border-box
  .datanalysis
    width 100%
    height 100vh
    min-width 1900px
    padding-top 80px
    padding-bottom 20px

    .left
      width 9%
      height 100%
      background #ffffff
      float left

      .left-one
        width 100%
        height 100%
        padding 20px 0
        box-sizing border-box

        .left-one-item
          width 100%
          height 50px
          line-height 40px
          padding 0 20px 0 30px
          box-sizing border-box
          cursor pointer

          div
            float left

            i
              color #b7b9bb
              float left

            span
              color #333
              font-size 15px
              font-weight bold
              margin-left 10px

          .icon-up
            float right

          .rotate
            transform rotate(-180deg)
            transition .3s

      .left-two
        width 100%
        cursor pointer

        .left-two-item
          width 100%
          height 40px
          font-size 14px
          color #777777
          padding-left 64px
          box-sizing border-box
          line-height 40px

        .select
          transition .3s
          background #006EC7 !important
          color #ffffff !important

    .right
      width 91%
      height 100%
      padding 0 21px
      box-sizing border-box
      float right
      overflow-y scroll
      padding-bottom 50px

      .oneTableIframe
        width 100%
        height 100%

      .item-title
        width 100%
        padding 20px 30px
        box-sizing border-box
        position absolute
        top 0
        left 0

        span
          font-weight bold
          color #222222
          font-size 16px

      .title
        width 100%
        height 50px
        margin-top 5px
        line-height 50px

        span
          font-size 16px
          color #222222
          font-weight bold

      .school
        width 100%
        height 320px

        .school-item
          width 32.8%
          height 100%
          background #ffffff
          border-radius 8px
          position relative

          .staffBox
            width 100%
            height 100%

          .listBox
            width 45%
            height 100%
            position absolute
            right 0
            bottom 0
            display flex
            flex-direction column
            justify-content center
            padding-left 30px
            padding-top 45px
            box-sizing border-box

            .item
              width 80%
              margin 5.5px 0
              display flex
              justify-content space-between
              .itemLeft
                width 80%
                display flex
                align-items center
              .kuai
                width 10px
                height 10px
                margin-right 10px
              .name
                font-size 14px
                color #666
              .value
                font-size 14px
                color #666
            .more
              width 80%
              display flex
              justify-content flex-end
              font-size 12px
              margin-top 10px
              cursor pointer
              color #006ec7

          .studentBox
            width 100%
            height 100%

        .scholl-item-one
          margin-right 15px
          float left

        .scholl-item-two
          float right

        .scholl-item-three
          overflow hidden

          .sexBox
            width 100%
            height 100%

      .book
        width 100%
        height 370px

        .book-item
          height 100%
          background #ffffff
          border-radius 8px
          position relative

          .bookBox
            width 100%
            height 100%

          .bookrankBox
            width 100%
            height 100%
            padding 0 30px
            padding-top 55px

            .list
              width 100%
              height 20px
              line-height 20px
              margin-bottom 19px

              .list-left
                float left
                width 15%
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                font-size 14px
                color #666

              .preBox
                width 72%
                height 20px
                background #eee
                float left
                margin-left 15px

                .preCon
                  width 50%
                  height 100%
                  background #1F89DF
                  border-top-right-radius 10px
                  border-bottom-right-radius 10px

              .list-right
                width 10%
                float right
                text-align right

        .book-item-left
          width 66%
          height 100%
          float left

        .book-item-right
          width 32.75%
          height 100%
          float left
          margin-left 17px

      .student
        width 100%
        height 330px

        .student-item
          width 32.68%
          overflow hidden
          height 100%
          background #ffffff
          border-radius 8px
          position relative
          float left

          .item-title
            z-index 99

          .nationBox
            width 100%
            height 100%

          .topBox
            width 100%
            height 100%

          &:nth-of-type(2)
            margin 0 15px

</style>



// WEBPACK FOOTER //
// src/pages/datanalysis.vue